// extracted by mini-css-extract-plugin
export default {"errorWrapper":"OrderError_errorWrapper__VNSNX","errorItem":"OrderError_errorItem__2sOHW","ml15":"OrderError_ml15__RRYok","ml40":"OrderError_ml40__J+yPb"};